import { setSpecificMessage, notSize } from "valibot";
setSpecificMessage(
  notSize,
  (issue) => `Taille invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);